export const config = {
    authority: 'https://id.locate2u.com/',
    redirect_uri: 'https://shop-integrations.locate2u.com/callback',
    post_logout_redirect_uri: 'https://shop-integrations.locate2u.com/login',
    silent_redirect_uri: 'https://shop-integrations.locate2u.com/static/silent-renew.html'
};
